import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { RetakeButton } from 'page/ProfileScreen/Selfies/buttons/RetakeButton'
import { TakeButton } from 'page/ProfileScreen/Selfies/buttons/TakeButton'
import { UploadButton } from 'page/ProfileScreen/Selfies/buttons/UploadButton'
import { StandCameraInput } from 'page/ProfileScreen/Selfies/StandCameraInput'
import { Or } from 'page/ProfileScreen/Selfies/Or'
import { uploadQrModal, UploadQrModalStore } from 'page/ProfileScreen/UploadQrModal/UploadQrModalStore'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const StandCameraPanel = observer(() => {
  const { picture, selfies, camera } = store.profile.common
  const { seconds } = camera
  const error = camera.error || selfies.find(it => it.error)?.error
  const errors = !!error

  const onUpload = useLatestCallback(() => {
    uploadQrModal.open(new UploadQrModalStore())
  })

  const upload = opt.qr_upload && <UploadButton onUpload={onUpload} />
  const retake = <RetakeButton />
  const take = <TakeButton />

  return <Vertical gap={32} center>
    <StandCameraInput />

    {(picture || errors) && (
      <Vertical gap={12} wide>
        {retake}
        {upload && <Or />}
        {upload}
      </Vertical>
    )}

    {!picture && !errors && !seconds && (
      <Vertical gap={16} wide>
        {take}
        {upload && <Or />}
        {upload}
      </Vertical>
    )}
  </Vertical>
})
